module.exports = __webpack_public_path__ + "static/img/18.79d9cff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qingka1/18.jpg
// module id = eEbK
// module chunks = 16